import { React } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../Context/LanguageContext';

import TotalModalWrapper from '../../Model/Share/Normal/TotalModalWrapper';
import { ReactComponent as TermsDeleteIcon } from '../../image/Delete.svg';
import { ReactComponent as ExitButtonSvg } from '../../image/ExitButton.svg';

export default function ProvisionDeleteModal(props) {
  const { onClickExit, onClickExcuteDeleteProvision } = props;
  const { t } = useLanguage();

  return (
    <TotalModalWrapper>
      <ModalView>
        <ExitButtonWrapper onClick={onClickExit}>
          <ExitIcon />
        </ExitButtonWrapper>
        <RedTrashBoxWrapper>
          <RedTermsDeleteBox>
            <TermsDeleteImage />
          </RedTermsDeleteBox>
        </RedTrashBoxWrapper>
        <TotalWrapper>
          <Title>{t('myStoreSetting.terms.deleteProvisionTitle')}</Title>
          <TextWrapper>
            <Explanation>{t('myStoreSetting.terms.deleteProvisionConfirm')}</Explanation>
            <Explanation>{t('myStoreSetting.terms.deleteProvisionQuestion')}</Explanation>
          </TextWrapper>
        </TotalWrapper>
        <ButtonWrapper>
          <CancelButton onClick={onClickExit}>
            {t('myStoreSetting.cancel')}
          </CancelButton>
          <DeleteButton onClick={onClickExcuteDeleteProvision}>
            {t('myStoreSetting.delete')}
          </DeleteButton>
        </ButtonWrapper>
      </ModalView>
    </TotalModalWrapper>
  )
}


const ModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 354px;
  height: 200px;

  border-radius: 15px;
  box-shadow: 0px 40px 50px rgba(0, 0, 0, 0.1);
  background-color: ${props => props.theme.subBackground};
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  margin-top: 12px;

  width: 90.33%;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  
  justify-content: center;
  align-items: center;

  margin-top: 8px;
  
  // gap: 4px;
`;

const Explanation = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 12px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
`;

const RedTrashBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: -43px;

  width: 100%;
`;

const RedTermsDeleteBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  min-width: 86px;
  max-width: 86px;
  width: 86px;

  min-height: 86px;
  max-height: 86px;
  height: 86px;

  border-radius: 86px;
  background-color: ${props => props.theme.pointRed};
`;

const TermsDeleteImage = styled(TermsDeleteIcon)`
  width: 47px;
  height: 47px;

  color: ${props => props.theme.white};
`;

const ExitButtonWrapper = styled.div`
  position: absolute;
  top: 9px;
  right: 11px;

  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;

  &:hover {
    cursor: pointer;
  }
`;

const ExitIcon = styled(ExitButtonSvg)`
  width: 17px;
  height: 16px;

  & path,
  & rect {
    fill: ${props => props.theme.line};
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 28px;

  width: 100%;
  height: 52px;

  overflow: hidden;

  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
`;

const CancelButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 50%;
  height: 100%;

  background-color: ${props => props.theme.subKey};

  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const DeleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 50%;
  height: 100%;

  background-color: ${props => props.theme.buttonFill3};

  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.text};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.pointRed};
    color: ${props => props.theme.white};
  }
`;
